import Oidc from 'oidc-client'

export function log() {
  // document.getElementById('results').innerText = '';

  // Array.prototype.forEach.call(arguments, function (msg) {
  //     if (msg instanceof Error) {
  //         msg = "Error: " + msg.message;
  //     }
  //     else if (typeof msg !== 'string') {
  //         msg = JSON.stringify(msg, null, 2);
  //     }
  //     document.getElementById('results').innerHTML += msg + '\r\n';
  // });
}

const { hostname, port } = window.location
const clientUrl = `https://${hostname}${port && port > 0 ? `:${port}` : ''}`

const config = {
  authority: process.env.REACT_APP_IDENTITY_SERVER,
  client_id: hostname,
  redirect_uri: `${clientUrl}/#/user/loginresponse`,
  response_type: "code",
  scope: "openid profile IdentityServerAPI FrontEnd",
  post_logout_redirect_uri: `${clientUrl}/#/user/login`,
  silent_redirect_uri: `${clientUrl}/#/user/loginresponse`,
  automaticSilentRenew: true,
  revokeAccessTokenOnSignout: true,
  // userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
};

// // For Staging Release
// const config = {
//   authority: "https://dev-login.tracemark.tech",
//   client_id: hostname,
//   redirect_uri: `${clientUrl}/#/user/loginresponse`,
//   response_type: "code",
//   scope: "openid profile IdentityServerAPI FrontEnd",
//   post_logout_redirect_uri: `${clientUrl}/#/user/login`,
//   silent_redirect_uri: `${clientUrl}/#/user/loginresponse`,
//   automaticSilentRenew: true,
//   revokeAccessTokenOnSignout: true,
//   // userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
// };

const mgr = new Oidc.UserManager(config);

// mgr.getUser().then(function (user) {
//   if (user) {
//       console.log("User logged in", user.profile);
//   }
//   else {
//       console.log("User not logged in");
//   }
// });

export function login() {
  mgr.signinRedirect();
}

export function* getLoggedInUser() {
  return yield mgr.getUser().then(user => user, err => err)
    .catch(err => err);
}

export function api() {
  // mgr.getUser().then(function (user) {
  // const url = "https://localhost:5001/identity";
  // console.log(user)
  // const xhr = new XMLHttpRequest();
  // xhr.open("GET", url);
  // xhr.onload = function () {
  //     log(xhr.status, JSON.parse(xhr.responseText));
  // }
  // xhr.setRequestHeader("Authorization", `Bearer  ${user.access_token}`);
  // xhr.send();
  // });
  mgr.getUser()
    .then(user =>
      // console.log({user})
      fetch('https://localhost:5001/identity', {
        method: 'Get',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `bearer ${user.access_token}`
        }
      }).then((response) => response.json())
        .then((data) =>
          console.log(data)
        ).catch(err => {
          console.log(err);
        })
    )
    .catch((error) => console.log(error));

}

export function completeLogin() {
  return new Promise((resolve, reject) => {
    mgr.signinRedirectCallback()
      .then(user => {
        resolve(user);
      }, err => {
        if (err && err.toString().includes("No matching state found in storage")) {
          mgr.signinRedirect();
        }
        reject(err);
      }).catch(err => {
        if (err && err.toString().includes("No matching state found in storage")) {
          mgr.signinRedirect();
        }
        reject(err);
      });
  })
}

export function logout() {
  mgr.signoutRedirect();
  completeLogout()
}


export function completeLogout() {
  mgr.signoutRedirectCallback()
    .then(() => {
      mgr.removeUser()
      localStorage.clear()
    })
    .then(() => { })
    .catch(
      (error) => {
        console.log(error)
      }
    );
}

mgr.events.addAccessTokenExpiring(() => {
  mgr.signinSilent()
    .then((user) => {
      const userresponse = JSON.parse(localStorage.getItem('webappuser'))
      userresponse.accesstoken = user.access_token;
      localStorage.setItem('webappuser', JSON.stringify(userresponse))
    }).catch((err) => {
      console.log("silent renew error addAccessTokenExpiring", err);
    });
});

mgr.events.addAccessTokenExpired(() => {
  mgr.signinSilent()
    .then((user) => {
      const userresponse = JSON.parse(localStorage.getItem('webappuser'))
      userresponse.accesstoken = user.access_token;
      localStorage.setItem('webappuser', JSON.stringify(userresponse))
      console.log("silent renew Success addAccessTokenExpired");
    }).catch((err) => {
      console.log("silent renew error addAccessTokenExpired", err);
    });
});

mgr.signinSilentCallback().then(() => {
});

mgr.events.addUserSignedOut(() => {
  mgr.signoutRedirect()
  completeLogout()
})
